import FindFolderParentWrapper from 'owa-service/lib/contract/FindFolderParentWrapper';
import { addFolderToDefaultFolderMappings } from 'owa-session-store';

export default function addArchiveMappingsInSessionStore(
    archiveFindFolderResponse: FindFolderParentWrapper
) {
    const archiveRootFolder = archiveFindFolderResponse.ParentFolder;

    // Add archive root folder mapping to the session store
    addFolderToDefaultFolderMappings(
        archiveRootFolder.DistinguishedFolderId,
        archiveRootFolder.FolderId.Id
    );

    // Only add the distinguished children of archive root to the session store
    archiveFindFolderResponse.Folders.filter(
        folder =>
            folder.DistinguishedFolderId &&
            folder.ParentFolderId.Id == archiveRootFolder.FolderId.Id
    ).forEach(folder =>
        addFolderToDefaultFolderMappings(folder.DistinguishedFolderId, folder.FolderId.Id)
    );
}
